module.exports = __webpack_public_path__ + "img/gallery-item-2.c2dde745.jpg";